var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RawWaterfall',_vm._b({ref:"waterfall",attrs:{"auto-resize":false},on:{"reflowed":_vm.onReflowed}},'RawWaterfall',_vm.realProps,false),[(_vm.isMounted)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }